import { TranslocoDirective, TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TaskFilter } from '../../interfaces/task-filter';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatChipsModule} from '@angular/material/chips';
import { TaskFilterService } from './task-filter.service';
import { PriorityStatus } from 'design-system';

//TODO: test to move in app.config.ts
// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: "dd/MM/yyyy",
//   },
//   display: {
//       dateInput: "dd/MM/yyyy",
//       monthYearLabel: "LLLL yyyy",
//       dateA11yLabel: "dd/MM/yyyy",
//       monthYearA11yLabel: "MM yyyy",
//   },
// };

@Component({
  providers: [provideTranslocoScope('tasks')],
  selector: 'task-task-filter-dialog-component',
  imports: [TranslocoPipe,
    CommonModule, MatDialogModule, MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule, MatInputModule, MatDatepickerModule,
    MatChipsModule, TranslocoDirective, PriorityStatus,
  ],
  templateUrl: './task-filter-dialog-component.html',
  styleUrl: './task-filter-dialog-component.scss',
})
export class TaskFilterDialogComponent {
  filterForm: FormGroup;

  tipiTask: string[] = [];
  readonly priorities = ['Low', 'Medium', 'High'];
  // I tipi dei task nati in App si traducono, quelli da ERP restano come arrivano
  readonly typeKeys: Record<string, string> = {
    "Proposta d'ordine": 'types.orderProposal',
    'Preventivo': 'types.quote',
  };

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<TaskFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public taskFilter: TaskFilter,
    private taskFilterService: TaskFilterService,
  ) {

    // console.log("dati", taskFilter);
    // this.fillFormValue(taskFilter);
    this.filterForm = this.formBuilder.group({
      nome: [ taskFilter?.nome], // array - taskFilter.nome
      priorita: [ taskFilter.priorita ], // array - taskFilter.priorita
      dataInizio: [ taskFilter?.dataInizio ],
      dataFine: [ taskFilter?.dataFine ],
      stato: [ taskFilter?.stato ],
    });
  }

  ngOnInit(): void {
    this.loadTipiTask();
  }

  loadTipiTask() {
      this.taskFilterService.getTipiTask().subscribe({
        next: (res) => {
          this.tipiTask = res;
        },
        error: (err) => {
          console.log("Tipi task ERR", err);
        }
      });
    }

  onClose() {
    this.dialogRef.close();
  }

  onConfirmFilter() {
    // let taskFilter: TaskFilter = {};
    //TODO: add tipoDettaglio e priorita
    // taskFilter.stato = this.filterForm.controls['stato'].value;

    // let dtI = this.filterForm.controls['dataInizio'].value;
    // if(dtI) {
    //   taskFilter.dataInizio = this.formatDateLocal(dtI);
    // }
    // let dtF = this.filterForm.controls['dataFine'].value;
    // if(dtF) {
    //   taskFilter.dataFine = this.formatDateLocal(dtF);
    // }



    this.dialogRef.close(this.filterForm.value);
  }

  onCancelFilter() {
    // reset valori dei filtri
    this.filterForm.reset();
  }

  onTipoTaskSelect(event: any, tipoTask: string) {
    let tipoTaskArray: any[] = this.filterForm.get('nome')?.value || [];

    if(event.selected) {
      if (!tipoTaskArray.includes(tipoTask)) {
        tipoTaskArray.push(tipoTask)
      }
    } else {
        tipoTaskArray = tipoTaskArray.filter((item: string) => item !== tipoTask)
      }

    this.filterForm.patchValue({ nome: tipoTaskArray });
  }

  checkTipoTaskSelected(tipoTask: string): boolean {
    let tipoTaskArray: any[] = this.filterForm.get('nome')?.value || [];

    return tipoTaskArray.includes(tipoTask);
  }

  togglePriority(priority: string): void {
    const selectedPriorities: string[] = this.filterForm.get('priorita')?.value || [];
    const priorita = selectedPriorities.includes(priority)
      ? selectedPriorities.filter(item => item !== priority)
      : [...selectedPriorities, priority];

    this.filterForm.patchValue({ priorita });
  }

  checkPrioritySelected(priority: string): boolean {
    let priorityArray: any[] = this.filterForm.get('priorita')?.value || [];

    return priorityArray.includes(priority);
  }
}
